export interface DotPhraseSource {
  dot_phrase?: string;
  content?: string;
  value?: string;
}

type DotPhraseLibrary = ReadonlyArray<DotPhraseSource | null | undefined> | null | undefined;

/**
 * Builds the lowercase dot phrase to expansion text map used by prompt inputs.
 * Later libraries win on name collisions, so pass the most specific library last.
 */
export const buildDotPhraseMap = (...libraries: DotPhraseLibrary[]): Map<string, string> => {
  const result = new Map<string, string>();

  libraries.forEach((library) => {
    if (!Array.isArray(library)) return;

    library.forEach((macro) => {
      const dotPhrase = typeof macro?.dot_phrase === "string" ? macro.dot_phrase.trim() : "";
      const content =
        typeof macro?.content === "string"
          ? macro.content
          : typeof macro?.value === "string"
            ? macro.value
            : "";

      if (dotPhrase && content.trim()) {
        result.set(dotPhrase.toLowerCase(), content);
      }
    });
  });

  return result;
};
